/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';
import ModalExecuteAction from './ModalExecuteAction';
import { useState } from 'react';
import useUSDRequest from '../../hooks/useUSDRequest';

function ModalApproveUSD({ modalIsOpen, setIsOpen, action, text, actionColor, buttonText }: ModalProps) {
  const [showExecuteAction, setShowExecuteAction] = useState(false);
  const { approveReturnRequest, isLoading } = useUSDRequest();

  function closeModal() {
    setIsOpen(false);
  }

  const ModalChildren = () => {
    const onButtonClick = async (e: { preventDefault: () => void }) => {
      e.preventDefault();
      setIsOpen(false);
      setShowExecuteAction(true);
    };

    return (
      <div className={`modal-base general success action flex--4`}>
        <span onClick={closeModal}>&times;</span>
        <form>
          <h4>{text}</h4>
          {/* <Input
            {...OverideInputStyle}
            label="Input Password"
            className="user-form-input"
            height="60px"
            placeholder="123456"
            // value={`${userData?.firstName} ${userData?.lastName}`}
          /> */}

          <div className="button-cont flex--2">
            <button onClick={() => setIsOpen(false)}>Cancel</button>
            <button onClick={onButtonClick} style={{ backgroundColor: actionColor }}>
              {buttonText}
            </button>
          </div>
        </form>
      </div>
    );
  };

  const actionExecuter = () => {
    approveReturnRequest(() => {
      action?.();
      setShowExecuteAction(false);
    }, 'approve');
  };

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <ModalChildren />
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showExecuteAction}
        setIsOpen={setShowExecuteAction}
        text={text}
        action={actionExecuter}
        actionColor={actionColor}
        isLoading={isLoading}
      />
    </>
  );
}

export default ModalApproveUSD;
